(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Support multiple instances and avoid relying on currentScript
    var sections = document.querySelectorAll('.culinary-hero');
    if (!sections.length) return;

    sections.forEach(function(section){
      // --- Force on-load entrance + section fade-in mount ---
      function onReady() {
        section.classList.add('is-mounted'); // NEW: triggers overall section fade-in
        section.classList.add('is-loaded');  // existing: triggers child fade/slide
        revealVisible();
        startCounters(true); // NEW: start counters on load (slowly), even if above the fold

        // absolute fallback: force-reveal everything after 1.2s (CSP/IO issues)
        setTimeout(function(){
          section.querySelectorAll('[data-reveal]').forEach(function(el){
            el.classList.add('reveal-in');
          });
          startCounters(true);
        }, 1200);
      }

      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        requestAnimationFrame(onReady);
      } else {
        document.addEventListener('DOMContentLoaded', onReady, { once: true });
      }

      // --- Scroll reveal (with robust fallbacks) ---
      var toReveal = Array.prototype.slice.call(section.querySelectorAll('[data-reveal]'));
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('reveal-in');

              // Stagger any stats children
              if (entry.target.classList.contains('culinary-stats')) {
                var items = entry.target.querySelectorAll('.stat');
                items.forEach(function(el, i) {
                  el.style.setProperty('--delay', (i * 80) + 'ms');
                  el.classList.add('reveal-in');
                });
              }

              // Trigger counters when stats/any stat becomes visible
              if (entry.target.classList.contains('stat') || entry.target.classList.contains('culinary-stats')) {
                startCounters(false);
              }

              io.unobserve(entry.target);
            }
          });
        }, { root: null, rootMargin: '0px 0px 0px 0px', threshold: 0.01 });

        toReveal.forEach(function(el) { io.observe(el); });
      } else {
        // Fallback: reveal everything and start counters
        toReveal.forEach(function(el){ el.classList.add('reveal-in'); });
        startCounters(true);
      }

      function revealVisible() {
        var viewportH = window.innerHeight || document.documentElement.clientHeight;
        toReveal.forEach(function(el) {
          var rect = el.getBoundingClientRect();
          if (rect.top < viewportH * 0.9) {
            el.classList.add('reveal-in');
          }
        });
      }

      // --- Counter animation for numbers (slower on load for visibility) ---
      var countersStarted = false;
      function startCounters(isInitial) {
        if (countersStarted) return;

        var stats = section.querySelectorAll('.stat-number');
        if (!stats.length) return;

        // Decide duration: slower on initial load for visibility
        var baseDuration = isInitial ? 2600 : 1600; // ms

        // If any stat is on screen, start; if it's the initial call, start anyway
        if (!isInitial) {
          var viewportH = window.innerHeight || document.documentElement.clientHeight;
          var anyVisible = false;
          stats.forEach(function(el){
            var rect = el.getBoundingClientRect();
            if (rect.top < viewportH * 0.95) anyVisible = true;
          });
          if (!anyVisible) return;
        }

        countersStarted = true;

        stats.forEach(function(el){
          if (el.classList.contains('counted')) return;

          var target = parseFloat(el.getAttribute('data-count-to') || '0');
          var decimalsAttr = el.getAttribute('data-decimals');
          var decimals = decimalsAttr ? parseInt(decimalsAttr, 10) : (String(target).includes('.') ? (String(target).split('.')[1] || '').length : 0);
          var suffix = el.getAttribute('data-suffix') || '';
          var duration = baseDuration;
          var startTime = null;

          function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }

          function tick(ts){
            if (!startTime) startTime = ts;
            var p = Math.min(1, (ts - startTime) / duration);
            var eased = easeOutCubic(p);
            var current = target * eased;

            var display = decimals > 0 ? current.toFixed(decimals) : Math.round(current).toString();
            el.textContent = display + suffix;

            if (p < 1) {
              requestAnimationFrame(tick);
            } else {
              var finalDisplay = decimals > 0 ? target.toFixed(decimals) : Math.round(target).toString();
              el.textContent = finalDisplay + suffix;
              el.classList.add('counted');
            }
          }

          // Respect reduced-motion but still snap to final values
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            var finalDisplay = decimals > 0 ? target.toFixed(decimals) : Math.round(target).toString();
            el.textContent = finalDisplay + suffix;
            el.classList.add('counted');
          } else {
            requestAnimationFrame(tick);
          }
        });
      }

      // --- Small parallax tilt on the image container ---
      var imageWrap = section.querySelector('[data-animate="image"]');
      if (imageWrap) {
        var img = imageWrap.querySelector('.image-display');
        var maxTilt = 6; // degrees
        var rafId;

        function onMove(e) {
          if (!img) return;
          var rect = imageWrap.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) - 0.5;
          var y = ((e.clientY - rect.top) / rect.height) - 0.5;
          cancelAnimationFrame(rafId);
          rafId = requestAnimationFrame(function() {
            img.style.transform = 'translateY(0) rotateX(' + (-y * maxTilt) + 'deg) rotateY(' + (x * maxTilt) + 'deg) scale(1.01)';
          });
        }
        function onLeave() {
          cancelAnimationFrame(rafId);
          img.style.transform = 'translateY(0) scale(1.01)';
        }

        imageWrap.addEventListener('mousemove', onMove);
        imageWrap.addEventListener('mouseleave', onLeave);
      }

      // As a belt-and-braces fallback, also check on scroll/resize
      window.addEventListener('scroll', revealVisible, { passive: true });
      window.addEventListener('resize', revealVisible);
    });
  })();
  
  } catch(e) { console.error(e); }
})();
})();
